import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';

import {Link} from '@homeaway/react-localization-components';

import translate from '../../../utils/translations';
import {TripDateSummary} from './TripDateSummary/TripDateSummary';
import {PropertyContact} from '../PropertyContact/PropertyContact';
import {StayConsumer} from '../../context/StayContext';
import {withErrorBoundary} from '../../ErrorBoundary/ErrorBoundary';

import {FallbackUI} from '../../molecules/FallbackUI/FallbackUI';

import './TripSummaryCard.less';

class TripSummaryCard extends React.Component {
    static propTypes = {
        backUrl: PropTypes.string,
        conversationId: PropTypes.string,
        departureDate: PropTypes.string,
        fullPhoneNumber: PropTypes.string,
        handelBannerClick: PropTypes.func,
        propertyImageC5: PropTypes.string,
        propertyUrl: PropTypes.string,
        reservationUuid: PropTypes.string,
        responseTime: PropTypes.string,
        showSendMessageBtn: PropTypes.bool,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        backUrl: '/traveler/th/inbox',
    };

    statusLabel(reservationStatus, statusCode, statusDescription) {
        if (!statusDescription) {
            statusDescription = reservationStatus; // reservationstatus should be shown in case of inquiry
        }
        switch (statusCode) {
            case 'RESERVE':
                return (
                    <span className="label label-success">
                        {statusDescription}
                    </span>
                );
            case 'CANCEL':
                return (
                    <span className="label label--black">
                        {statusDescription}
                    </span>
                );
            default:
                return (
                    <span className="label label-default">
                        {statusDescription}
                    </span>
                );
        }
    }

    render() {
        const {
            arrivalDate,
            backUrl,
            contact,
            departureDate,
            conversationId,
            fullPhoneNumber,
            handelBannerClick,
            ownerAvatar,
            propertyImageC5,
            propertyUrl,
            reservationUuid,
            responseTime,
            showIpmHostInfo,
            showSendMessageBtn,
            translations,
        } = this.props;
        return (
            <div className="TripSummaryCard rounded-border">
                <div className="TripSummaryCard__TripDateSummary_Wrapper">
                    <div className="overlay-link">
                        <Link
                            href={propertyUrl}
                            target="_blank"
                            className="property-image hidden-xs"
                            style={{
                                backgroundImage: `url('${propertyImageC5}')`,
                            }}
                            onClick={
                                /* istanbul ignore next */ () =>
                                    handelBannerClick(
                                        reservationUuid,
                                        departureDate,
                                        arrivalDate
                                    )
                            } //eslint-disable-line
                        >
                            <StayConsumer>
                                {(stayData) => {
                                    const booking = stayData.stay.booking;
                                    return (
                                        booking.reservationStatus && (
                                            <div className="booking-status__label">
                                                {booking &&
                                                    this.statusLabel(
                                                        booking.reservationStatus,
                                                        booking.status?.code,
                                                        booking.status
                                                            ?.description
                                                    )}
                                            </div>
                                        )
                                    );
                                }}
                            </StayConsumer>
                        </Link>
                        <TripDateSummary
                            handelBannerClick={handelBannerClick}
                            translations={translations}
                        />
                    </div>
                </div>
                {!isEmpty(contact) && (
                    <PropertyContact
                        avatar={ownerAvatar || contact.ownerProfilePhoto}
                        backUrl={backUrl}
                        conversationId={conversationId}
                        memberSince={contact.memberSince}
                        ownerName={contact.name}
                        phone={fullPhoneNumber}
                        responseTime={responseTime}
                        showIpmHostInfo={showIpmHostInfo}
                        showSendMessageBtn={showSendMessageBtn}
                        translations={translations}
                    />
                )}
            </div>
        );
    }
}

const TripSummaryCardWithErrorBoundary = (props) => {
    const {translations} = props;
    const ERROR_BOUNDARY_TEXT = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'error.boundary.message'
    );
    const ERROR_BOUNDARY_TITLE = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.confirmation.rentalInfo.title'
    );
    return withErrorBoundary(
        <TripSummaryCard {...props} />,
        'trip-summary-card',
        <FallbackUI
            errorText={ERROR_BOUNDARY_TEXT}
            title={ERROR_BOUNDARY_TITLE}
        />
    );
};
export {TripSummaryCardWithErrorBoundary as TripSummaryCard};
